import { readRecommendation } from "@intelligems/ig-types/schemas/ai/ui-actions/audit-recommendation";
import type { RecommendationSetItem } from "@src/store/slices/opportunityAudit/types";

export type ReadSetItem = Pick<
  RecommendationSetItem,
  "key" | "recommendation" | "placeholder"
>;

/**
 * A recommendation as a payload carried it, read at today's version. One that
 * does not read keeps its key, so its status still loads.
 */
export function setItemOf(
  raw: unknown,
  call: string,
  position: number
): ReadSetItem {
  const id =
    raw && typeof raw === "object"
      ? (raw as { recommendationId?: unknown }).recommendationId
      : undefined;
  const key = typeof id === "string" && id !== "" ? id : `${call}:${position}`;
  const read = readRecommendation(raw);
  return read.type === "read"
    ? { key, recommendation: read.value }
    : { key, recommendation: null, placeholder: read.type };
}
